<script lang="ts">
    export let width = '526';
</script>

<svg {width} height="531" viewBox="0 0 526 531" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M271.444 444.198C315.159 444.198 405.711 419.074 405.711 276.498C405.711 159.046 335.143 96.2375 258.329 96.2375C177.144 96.2375 116.568 149.625 116.568 257.028C115.943 370.711 184.014 444.198 271.444 444.198ZM261.452 79.9072C370.739 79.9072 451.924 148.997 451.924 262.681C451.924 371.968 375.111 462.412 258.329 462.412C125.311 462.412 70.355 358.15 70.355 270.218C70.355 191.707 127.184 79.9072 261.452 79.9072Z"
        fill="#FDFCFD"
    />
    <path
        d="M248.324 246.356L258.321 248.241L267.068 242.585V241.957L253.947 228.761L248.324 246.356Z"
        fill="#FDFCFD"
    />
    <path d="M238.953 262.688L247.076 257.033L248.325 246.35L230.206 245.722L238.953 262.06V262.688Z" fill="#FDFCFD" />
    <path d="M277.066 285.295L267.069 283.41L258.947 289.694L271.443 302.89L277.066 285.295Z" fill="#FDFCFD" />
    <path d="M286.416 269.588L278.919 275.243L277.044 285.298V285.926H295.164L286.416 269.588Z" fill="#FDFCFD" />
    <path
        d="M258.944 289.691L252.696 281.522L243.324 279.637V280.265L242.699 298.488L258.944 290.319V289.691Z"
        fill="#FDFCFD"
    />
    <path
        d="M243.332 280.275V279.647L244.582 270.221L238.959 262.68V262.052L225.838 274.62L243.332 280.275Z"
        fill="#FDFCFD"
    />
    <path d="M309.527 255.145L304.528 252.632L299.53 257.031L307.028 259.544L309.527 255.145Z" fill="#FDFCFD" />
    <path
        d="M309.525 255.142L310.149 254.514L320.766 263.935L350.117 272.728L525.602 203.011L337.627 219.969L315.145 241.952L309.525 255.142Z"
        fill="#FDFCFD"
    />
    <path d="M216.474 276.501L220.848 279.643L225.846 274.616L218.348 272.73L216.474 276.501Z" fill="#FDFCFD" />
    <path
        d="M215.852 276.495V277.123L204.611 268.33L175.259 258.908L0.399414 328.626L187.749 311.667L210.231 289.684L215.852 276.495Z"
        fill="#FDFCFD"
    />
    <path
        d="M251.436 218.713L250.811 219.341L260.803 208.035L270.171 177.887L200.227 0.766602L217.088 190.449L238.321 213.06L251.436 218.713Z"
        fill="#FDFCFD"
    />
    <path d="M250.823 219.341L248.324 223.111L253.947 228.767L255.821 222.483L250.823 219.341Z" fill="#FDFCFD" />
    <path d="M274.549 312.305L277.048 308.534L271.425 302.879L269.55 309.163L274.549 312.305Z" fill="#FDFCFD" />
    <path
        d="M273.93 313.555L274.554 312.927L265.187 324.232L255.819 353.752L325.763 530.873L308.277 341.191L287.044 319.208L273.93 313.555Z"
        fill="#FDFCFD"
    />
    <path d="M267.067 241.956V242.584L273.315 250.753L282.687 252.01V233.158L266.443 241.956H267.067Z" fill="#FDFCFD" />
    <path d="M282.677 252L280.802 261.426L286.425 269.595H287.05L299.546 257.028L282.677 251.372V252Z" fill="#FDFCFD" />
</svg>
